import GCUMsgHandler from '../../modules/GCUMsgHandler';

const config = {
  gcuCmdInterval: 300000
};

const state = {
  siteStatusSub: null
};

const mutations = {
  setSiteStatusSub(state, siteStatusSub) {
    state.siteStatusSub = siteStatusSub;
  }
};

const actions = {
  async monitorSiteStatus({ commit, state }) {
    if (state.siteStatusSub) return;

    if (!this.$broker.siteStatusQueue) {
      this.$broker.siteStatusQueue = this.$broker.genUserQueueName();
    }
    const siteStatusSub = await this.$broker.subscribe(this.$broker.siteStatusQueue, (msg) => {
      msg.ack();
      const unpackedMsg = new GCUMsgHandler(msg);

      switch (unpackedMsg.command) {
        case '739':
          // If the gcu is site status supported, start an interval to get the site status
          if (unpackedMsg.body.features.indexOf('site_status') >= 0) {
            commit('savanna/gcus/setStatusSupportedGCUs', unpackedMsg.gcu, { root: true });

            this.$broker.sendGCUCommand('738', unpackedMsg.gcu, this.$broker.siteStatusQueue);
            setInterval(() => {
              this.$broker.sendGCUCommand('738', unpackedMsg.gcu, this.$broker.siteStatusQueue);
            }, config.gcuCmdInterval);
          }
          break;
        case '738':
          commit('savanna/trackers/setTrackerStatus', unpackedMsg, { root: true });
          break;
        default:
          break;
      }
    });
    commit('setSiteStatusSub', siteStatusSub);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
